export const ROUTE_NAME = {
  HOME: "home",
  LOGIN: "login",
  LOGIN_PASSWORD: "login-password",
  LOGIN_MAGIC_LINK: "auth-magic-link",
  SELECT_ORGANIZATION: "select-organization",
  LOGOUT: "logout",
  FORGOT_PASSWORD: "forgot-password",
  RESET_PASSWORD: "reset-password",

  ANNOUNCEMENTS: "announcements",
  ANNOUNCEMENTS_LIST: "announcements-list",
  ANNOUNCEMENT_COMPOSE: "announcement-compose",
  ANNOUNCEMENT_EDIT: "announcement-edit",

  EMAILS: "emails",
  EMAIL_LIST: "email-list",
  EMAIL_COMPOSE: "email-compose",

  TRAINING_COLLECTIONS: "training-collection",
  TRAINING_COLLECTION_LIST: "training-collection-list",
  TRAINING_COLLECTION_UPDATE: "training-collection-single",

  DRILL_UPDATE: "drill-update",

  CALENDARS: "calendars",
  WORKOUTS: "workouts",
  WORKOUT_LIST: "workout-list",
  WORKOUT_UPDATE: "workout-single",
  WORKOUT_CREATE: "workout-create",

  EXERCISES: "exercises",
  EXERCISE_LIST: "exercise-list",
  EXERCISE_UPDATE: "exercise-single",
  EXERCISE_CREATE: "exercise-create",

  USERS: "users",
  USER_LIST: "user-list",
  USER_DETAIL: "user-detail",
  USER_UPDATE: "user-single",
  USER_CREATE: "user-create",

  CHAT_CHANNELS: "chat-channels",
  CHAT_CHANNELS_LIST: "chat-channels-list",
  CHATS: "chats",
  CHAT_LIST: "chat-list",
  CHAT_SINGLE: "chat-single",
  CHAT_MESSAGE: "chat-message",

  ORGANIZATIONS: "organizations",
  ORGANIZATION_LIST: "organization-list",
  ORGANIZATION_UPDATE: "organization-single",
  ORGANIZATION_CREATE: "organization-create",

  ORGANIZATION_SETTINGS: "organization-settings",
  QUICK_LINKS: "quick-links",
  WEBSITE: "website",

  TEAM_LIST: "team-list",
  TEAM_UPDATE: "team-single",
  TEAM_CREATE: "team-create",

  GLOBAL_SETTINGS: "settings",

  SENTRY: "sentry",

  PROFILE_UPDATE: "profile-single",

  PAYMENT_INVOICES: "payment-invoices",
  PAYMENT_LOG: "payment-log",
  PAYMENT_LOG_NEW: "payment-log-new",
  PAYABLI_TEST: "payabli-test",
  PAYMENT_REGISTRATIONS: "payment-registrations",
  PAYMENT_OFFERINGS_CREATE: "payment-offerings-create",
  PAYMENT_OFFERINGS_EDIT: "payment-offerings-edit",
  PAYMENT_REGISTRANT_VIEW: "payment-registrant-view",
  CREATE_INVOICE: "create-invoice",
  VIEW_INVOICE: "view-invoice",
  EDIT_INVOICE: "edit-invoice",
  PAYMENT_MEMBERSHIPS: "payment-memberships",
  PAYMENT_MEMBERSHIPS_VIEW: "payment-memberships-view",
  PAYMENT_MEMBERSHIP_EDIT: "payment-membership-edit",
  PAYMENT_MEMBERSHIPS_MEMBER_VIEW: "payment-memberships-member-view",
  PAYMENT_REGISTRATIONS_VIEW: "payment-registrations-view",
  CREATE_OFFERING_SIGNUP: "create-offering-signup",
  ORGANIZATION_PAYMENT_SETTINGS: "organization-payment-settings",
  PAYMENT_BENEFITS_LIST: "payment-benefits-list",

  STATS_CATEGORIES: "list-stat-categories",
  CREATE_STAT_CATEGORY: "create-stat-category",
  UPDATE_STAT_CATEGORY: "update-stat-category",

  BOOKINGS: "bookings",
  BOOKED_SESSIONS: "booked-sessions",
  BOOKINGS_SERVICES: "bookings-services",
  BOOKINGS_SERVICE_CREATE: "bookings-service-create",
  BOOKINGS_SERVICE_EDIT: "bookings-service-edit",
  BOOKINGS_INSTRUCTOR: "bookings-instructor",
  BOOKINGS_INSTRUCTOR_CREATE: "bookings-instructor-create",
  BOOKINGS_INSTRUCTOR_EDIT: "bookings-instructor-edit",
  BOOKINGS_SETUP: "bookings-setup",
  BOOKING_DETAIL: "booking-detail",
  BOOKING_DETAIL_EDIT: "booking-detail-edit",

  BOOKINGS_ASSET_CREATE: "bookings-asset-create",
  BOOKINGS_ASSET_EDIT: "bookings-asset-edit",
  BOOKINGS_CREATE: "bookings-create",

  SCHEDULE: "schedule",

  // Network Admin routes
  NETWORK_ADMIN: "network-admin",
  NETWORK_MANAGEMENT: "network-management",
  NETWORK_CREATE_ORGANIZATION: "network-create-organization",
  NETWORK_ORGANIZATION_DETAIL: "network-organization-detail",
} as const;

export const LOGIN_PATH = "/login";
export const LOGIN_EMAIL_PATH = "/login-email/:email?";
export const LOGOUT_PATH = "/logout";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const RESET_PASSWORD_PATH = "/reset-password";
export const LOGIN_MAGIC_LINK_PATH = "/login/magic-link/:token";
export const SELECT_ORGANIZATION_PATH = "/select-organization";
